import { SVGProps, Ref, forwardRef } from 'react';

export const HyperstarSparkleOutlinedSize48Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={48}
            height={48}
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M18 12c4.5 6.75 11.25 13.5 18 18-6.75 4.5-13.5 11.25-18 18-4.5-6.75-11.25-13.5-18-18 6.75-4.5 13.5-11.25 18-18m0 6.102A74.4 74.4 0 0 1 6.102 30 74.4 74.4 0 0 1 18 41.897 74.4 74.4 0 0 1 29.897 30 74.4 74.4 0 0 1 18 18.102"
                        fill="currentColor"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M38 0c2.5 3.75 6.25 7.5 10 10-3.75 2.5-7.5 6.25-10 10-2.5-3.75-6.25-7.5-10-10 3.75-2.5 7.5-6.25 10-10m0 5.889A43 43 0 0 1 33.889 10 43 43 0 0 1 38 14.11 43 43 0 0 1 42.11 10 43 43 0 0 1 38 5.889"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
HyperstarSparkleOutlinedSize48Glyph.displayName = 'HyperstarSparkleOutlinedSize48Glyph';
